import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-session-timeout',
  templateUrl: './session-timeout.component.html'
})
export class SessionTimeoutComponent implements OnInit {

  constructor( private router: Router) { }

  ngOnInit(): void {
  }

  redirectToLogin(){
    this.router.navigate(['/employer/login']);
  }

}
